import { ScoreLabel } from "../app/types";
import { LogHeader, SampleSummary } from "../client/api/types";

/**
 * Extracts scorer information from sample summaries
 */
const getScorersFromSamples = (samples: SampleSummary[]): ScoreLabel[] => {
  const dictScorers = new Set<string>();
  const scoreLabelsMap = new Map<string, ScoreLabel>();
  for (const sample of samples) {
    if (sample.error || !sample.scores) continue;
    for (const [scorerKey, scoreValue] of Object.entries(sample.scores)) {
      if (
        scoreValue.value &&
        typeof scoreValue.value === "object" &&
        !Array.isArray(scoreValue.value)
      ) {
        dictScorers.add(scorerKey);
        for (const innerKey of Object.keys(scoreValue.value)) {
          const label = `${scorerKey}:${innerKey}`;
          if (!scoreLabelsMap.has(label)) {
            scoreLabelsMap.set(label, { name: innerKey, scorer: scorerKey });
          }
        }
      } else if (!scoreLabelsMap.has(scorerKey)) {
        scoreLabelsMap.set(scorerKey, { name: scorerKey, scorer: scorerKey });
      }
    }
  }
  // Drop any bare scorer-name labels that crept in from NaN/unscored
  // samples on dict-shaped scorers — they'd render a redundant
  // whole-dict column alongside the unpacked inner-key columns.
  for (const scorerKey of dictScorers) {
    scoreLabelsMap.delete(scorerKey);
  }
  return Array.from(scoreLabelsMap.values());
};

/**
 * Gets all available scorers for a log, prioritizing results over samples
 */
export const getAvailableScorers = (
  _log: LogHeader,
  sampleSummaries: SampleSummary[]
): ScoreLabel[] | undefined => {
  const sampleScorers = getScorersFromSamples(sampleSummaries);
  if (sampleScorers.length > 0) {
    return sampleScorers;
  }
  return undefined;
};
